import { GLOBALS } from '../Globals'

export function getAvailableRoles(userLogged) {
  if (userLogged.role === GLOBALS.roles.admin.id) {
    return [GLOBALS.roles.admin, GLOBALS.roles.teacher, GLOBALS.roles.student]
  }

  if (userLogged.role === GLOBALS.roles.teacher.id) {
    return [GLOBALS.roles.teacher, GLOBALS.roles.student]
  }

  return [GLOBALS.roles.student]
}

export function getRole(id) {
  const index = Object.keys(GLOBALS.roles).find((key) => GLOBALS.roles[key].id === id)

  if (index) {
    return GLOBALS.roles[index]
  }
}
